import { useEffect } from 'react'
import { useLocation } from 'wouter'
import { appRoutes } from '@/app/routes'
import { wasPopNavigation } from '@/app/navigation'

export function RouteFocus() {
  const [pathname] = useLocation()
  useEffect(() => {
    const timer = window.setTimeout(() => {
      const route = appRoutes.find((item) => item.path === pathname)
        ?? appRoutes.find((item) => item.path.includes('/:') && pathname.startsWith(item.path.split('/:')[0]))
      document.title = `${route?.title ?? (pathname === '/login' ? '管理员登录' : '管理端')} · 乐学 Welearn`
      if (!wasPopNavigation()) {
        document.getElementById('main-content')?.focus({ preventScroll: true })
        window.scrollTo({ top: 0, behavior: 'instant' })
      }
    }, 0)
    return () => window.clearTimeout(timer)
  }, [pathname])
  return null
}
